import React, { useEffect, useRef, useState } from "react";
import Dashboard from "../../layouts/Dashboard";
import { ReactLoading } from "../Dashboard/TinManagement/import";
import {
  CopyOutlined,
  DeleteFilled,
  DownOutlined,
  EditFilled,
  EllipsisOutlined,
  LockOutlined,
  MailOutlined,
  PlusOutlined,
  RightOutlined,
  SearchOutlined,
  UserAddOutlined,
  UserOutlined,
  StopOutlined
} from "@ant-design/icons";
import {
  Avatar,
  Button,
  Card,
  DatePicker,
  Input,
  Popover,
  Select,
  Table,
  Result
} from "antd";
import { useHistory, useLocation } from "react-router-dom";
import Cards from "./components/Cards";
import UnassignedLeads from "./UnassignedLeads";
import InactiveAmeyoLeads from "./InactiveAmeyoLeads";
import useAxios from "../../hooks/useAxios";
import moment, { isMoment } from "moment";
import { checkBulkPermissions } from "../../utils/checkPermission";
import useRole from "../../hooks/useRole";

const { RangePicker } = DatePicker;
const TAB_CARDS = [
  {
    key: "outCall",
    label: "OUT CALL REQUIRED",
    value: 0,
    child: [
      {
        key: "dialed",
        label: "Dialed",
        value: 0,
      },

      {
        key: "pending",
        label: "Pending",
        value: 0,
      },
    ],
  },
  {
    key: "scheduledCall",
    label: "SCHEDULED Call",
    value: 0,
    child: [
      {
        key: "completed",
        label: "Completed",
        value: 0,
      },

      {
        key: "pending",
        label: "Pending",
        value: 0,
      },
    ],
  },
  {
    key: "callNow",
    label: "CALL NOW",
    value: 0,
    child: [
      {
        key: "completed",
        label: "Completed",
        value: 0,
      },
    ],
  },
  {
    key: "callOverDue",
    label: "CALL OVERDUE",
    value: 0,
    child: [
      {
        key: "scheduled",
        label: "Scheduled",
        value: 0,
      },
      {
        key: "callNow",
        label: "Call Now",
        value: 0,
      },
    ],
  },
];

const ManagerDashboard = () => {
  const history = useHistory();
  const location = useLocation();
  const api = useAxios();
  const searchParams = new URLSearchParams(location.search);
  const isUnassignedInitial =
    searchParams.get("unassigned") === "true" || location.state?.unassigned === true;
  const isInactiveAmeyoInitial =
    searchParams.get("isServiceActive") === "false" || location.state?.isInactiveAmeyo === true;

  const [loading, setLoading] = useState(false);
  const [tabCards, setTabCards] = useState(TAB_CARDS);
  const [walkInCount, setWalkInCount] = useState(0);
  const [isUnAssignedOpen, setIsUnAssignedOpen] = useState(isUnassignedInitial);
  const [isInactiveAmeyoOpen, setIsInactiveAmeyoOpen] = useState(isInactiveAmeyoInitial);

  useEffect(() => {
    const searchUnassigned = new URLSearchParams(location.search).get("unassigned") === "true";
    const searchInactive = new URLSearchParams(location.search).get("isServiceActive") === "false";
    if (searchUnassigned || location.state?.unassigned) {
      setIsUnAssignedOpen(true);
      setIsInactiveAmeyoOpen(false);
    } else if (searchInactive || location.state?.isInactiveAmeyo) {
      setIsInactiveAmeyoOpen(true);
      setIsUnAssignedOpen(false);
    }
  }, [location.search, location.state]);
  const [tableData, setTableData] = useState([]);
  const [dateFilter, setDateFilter] = useState("30_days");
  const [dateRange, setDateRange] = useState([
    moment(new Date()).subtract(1, "month").format("YYYY-MM-DD"),
    moment(new Date()).format("YYYY-MM-DD"),
  ]);
  const [startDate, setStartDate] = useState();
  const [candidates, setCandidates] = useState({
    records: [],
    totalRecords: 0,
  });
  const [inactiveAmeyoCount, setInactiveAmeyoCount] = useState(0);

  const role = useRole();
  const [permissions, setPermissions] = useState({
    canViewDashboard: false,
    canViewUnassigned: false,
  });
  const [checkingPermissions, setCheckingPermissions] = useState(true);

  useEffect(() => {
    const fetchPermissions = async () => {
      if (!role) return;
      try {
        const checks = [
          { entityType: "manager_dashboard_module", permission: "view_permission" },
          { entityType: "manager_dashboard_module", permission: "view_unassigned_leads" }
        ];
        const results = await checkBulkPermissions(role, checks);

        const perms = {
          canViewDashboard: false,
          canViewUnassigned: false
        };
        results.forEach(res => {
          if (res.permission === "view_permission") perms.canViewDashboard = res.allowed;
          if (res.permission === "view_unassigned_leads") perms.canViewUnassigned = res.allowed;
        });

        setPermissions(perms);
      } catch (err) {
        console.error(err);
      } finally {
        setCheckingPermissions(false);
      }
    };

    fetchPermissions();
  }, [role]);

  const columns = [
    {
      title: "Recruiter",
      dataIndex: "recruiter",
      key: "recruiter",
      render: (value) => {
        return <span className="capitalize">{value}</span>;
      },
    },
    {
      title: "Location Assigned",
      dataIndex: "location_assigned",
      key: "location_assigned",
      render: (value) => {
        if (!Array.isArray(value) || value.length === 0) {
          return "-";
        }

        const names = value.map((item) => item).filter(Boolean);
        const first = names[0];
        const restCount = names.length - 1;
        return (
          <Popover
            content={
              <div className="flex flex-col gap-[10px]">
                {names.map((name, i) => (
                  <div key={i} className="capitalize flex gap-[10px]">
                    {name}
                  </div>
                ))}
              </div>
            }
            title="All Locations Assigned"
            trigger="click"
            placement="bottomRight"
          >
            <span className="capitalize cursor-pointer flex gap-[10px] items-center">
              {first ? <>{first || "-"}</> : "-"}
              {restCount > 0 && (
                <span
                  className="ml-1 flex items-center justify-center"
                  style={{
                    width: "23px",
                    height: "23px",
                    border: "1px solid #FFA94D",
                    color: "#FA8C16",
                    borderRadius: "50%",
                    fontSize: "12px",
                    fontWeight: 500,
                    backgroundColor: "#FFF7E6",
                  }}
                >
                  +{restCount}
                </span>
              )}
            </span>
          </Popover>
        );
      },
    },
    {
      title: "Rules Applied",
      dataIndex: "rules_applied",
      key: "rules_applied",
      render: (value) => {
        if (!Array.isArray(value) || value.length === 0) {
          return "-";
        }

        const names = value.map((item) => item).filter(Boolean);
        const first = names?.[0]?.ruleName;
        const restCount = names.length - 1;
        return (
          <Popover
            content={
              <div className="flex flex-col gap-[10px]">
                {names.map((item, i) => {
                  return (
                    <div key={i} className="capitalize flex gap-[10px]">
                      {item?.ruleName}{" "}
                      <EditFilled
                        onClick={() =>
                          history.push(`/rule-engine/edit/${item?._id}`)
                        }
                        className="cursor-pointer"
                        style={{ fontSize: "1.2rem", color: "grey" }}
                      />
                    </div>
                  );
                })}
              </div>
            }
            title="All Rules Applied"
            trigger="click"
            placement="bottomRight"
          >
            <span className="capitalize cursor-pointer flex gap-[10px] items-center">
              {first ? <>{first || "-"}</> : "-"}
              {restCount > 0 && (
                <span
                  className="ml-1 flex items-center justify-center"
                  style={{
                    width: "23px",
                    height: "23px",
                    border: "1px solid #FFA94D",
                    color: "#FA8C16",
                    borderRadius: "50%",
                    fontSize: "12px",
                    fontWeight: 500,
                    backgroundColor: "#FFF7E6",
                  }}
                >
                  +{restCount}
                </span>
              )}
            </span>
          </Popover>
        );
      },
    },
    {
      title: "Completed",
      dataIndex: "completed",
      key: "completed",
    },
    {
      title: "Schedule",
      dataIndex: "schedule",
      key: "schedule",
    },
  ];

  const getAllUnassignedLeads = async (page, pageSize) => {
    try {
      const { data } = await api.get(
        `/ruleEngine/unassigned-leads?PageNo=${page}&PageSize=${pageSize}&startDate=${dateRange[0]}&endDate=${dateRange[1]}`,
        { tokenType: "user" },
      );

      const records = data?.candidateList || [];

      const row = [];

      for (let item of records) {
        let qualification = "";
        let experience = "";

        item?.responses?.forEach((response) => {
          if (response?.label === "Highest Qualification") {
            qualification = response?.value || "";
          }
          if (response?.label === "Total Experience") {
            experience = response?.value || "";
          }
        });

        row.push({
          key: item?._id,
          date: new Date(item?.createdAt)?.toLocaleDateString("en-GB") || "",
          phone: item?.mobileNo,
          name: item?.name,
          location: item?.location,
          qualification: qualification,
          experience: experience,
        });
      }

      console.log(data);
      setCandidates({ records: row, totalRecords: data?.candidateCount || 0 });
    } catch (err) {
      console.error(err);
    }
  };

  const getInactiveAmeyoCount = async () => {
    try {
      const { data } = await api.get(
        `/candidates/Pagination?FormId=[]&PageSize=1&PageNo=1&TabType=Application_Received&InterviewType=Application_Received&isServiceActive=false&StartDate=${dateRange[0] || ""}&EndDate=${dateRange[1] || ""}`,
        { tokenType: "user" }
      );
      setInactiveAmeyoCount(data?.candidateCount || data?.totalRecords || 0);
    } catch (err) {
      console.error("Error fetching inactive ameyo count:", err);
    }
  };

  const getManagerDashboardData = async () => {
    try {
      const { data } = await api.get(
        `/ruleEngine/recruiter/all/grouped?startDate=${dateRange[0]}&endDate=${dateRange[1]}`,
        {
          tokenType: "user",
        },
      );
      const row = [];

      for (let item of data) {
        const locations = item?.rules?.flatMap(
          (rule) =>
            rule?.groups?.flatMap((group) =>
              group?.conditions
                ?.filter((c) => c?.label === "preferredLocation")
                ?.flatMap((c) => c?.value || []),
            ) || [],
        );
        row.push({
          key: item?.recruiter_id,
          recruiter: item?.recruiter?.name,
          rules_applied: item?.rules,
          location_assigned: [...new Set(locations)],
          completed: `${item?.completed} of ${item?.total}`,
          schedule: item?.scheduled,
        });
      }
      setTableData(row);
    } catch (err) {
      console.error(err);
    }
  };

  const getCounts = async () => {
    try {
      const { data } = await api.get(
        `/ruleEngine/manager-dashboard-count?startDate=${dateRange[0]}&endDate=${dateRange[1]}`,
        {
          tokenType: "user",
        },
      );
      console.log(data);
      const {
        callNow,
        callOverdue,
        outCallRequired,
        scheduledCall,
        walkInCount,
      } = data;

      const TAB_CARDS = [
        {
          key: "outCall",
          label: "OUT CALL REQUIRED",
          value: outCallRequired?.total || 0,
          child: [
            {
              key: "dialed",
              label: "Dialed",
              value: outCallRequired?.dialed || 0,
            },

            {
              key: "pending",
              label: "Pending",
              value: outCallRequired?.pending || 0,
            },
          ],
        },
        {
          key: "scheduledCall",
          label: "SCHEDULED Call",
          value: scheduledCall?.total || 0,
          child: [
            {
              key: "completed",
              label: "Completed",
              value: scheduledCall?.completed || 0,
            },

            {
              key: "pending",
              label: "Pending",
              value: scheduledCall?.pending || 0,
            },
          ],
        },
        {
          key: "callNow",
          label: "CALL NOW",
          value: callNow?.total || 0,
          child: [
            {
              key: "completed",
              label: "Completed",
              value: callNow?.completed || 0,
            },
          ],
        },
        {
          key: "callOverDue",
          label: "CALL OVERDUE",
          value: callOverdue?.total || 0,
          child: [
            {
              key: "scheduled",
              label: "Scheduled",
              value: callOverdue?.scheduled || 0,
            },
            {
              key: "callNow",
              label: "Call Now",
              value: callOverdue?.callNow || 0,
            },
          ],
        },
      ];
      setWalkInCount(walkInCount || 0);
      setTabCards(TAB_CARDS);
    } catch (err) {
      console.error(err);
    }
  };

  const getDateRange = (type) => {
    if (type === "7_days") {
      return [
        moment(new Date()).subtract(7, "day").format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD"),
      ];
    }

    if (type === "15_days") {
      return [
        moment(new Date()).subtract(15, "day").format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD"),
      ];
    }
    if (type === "30_days") {
      return [
        moment(new Date()).subtract(1, "month").format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD"),
      ];
    }

    if (type === "3_months") {
      return [
        moment(new Date()).subtract(3, "month").format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD"),
      ];
    }

    if (type === "today") {
      return [
        moment(new Date()).format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD"),
      ];
    }
  };

  useEffect(() => {
    const init = async () => {
      try {
        setLoading(true);
        await Promise.all([
          getAllUnassignedLeads(1, 10),
          getInactiveAmeyoCount(),
          getManagerDashboardData(),
          getCounts(),
        ]);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    init();
  }, []);

  const handleDate = (value, dateString) => {
    if (value === null) {
      setDateRange(["", ""]);
    } else {
      setDateRange([dateString[0], dateString[1]]);
    }
  };

  function disableFutureDates(current) {
    const maxDate = moment().add(7, "day");
    return current && current > maxDate;
  }

  const handleCalendarChange = (dates) => {
    if (dates && dates[0]) {
      setStartDate(dates[0]);
    }
  };

  const initialLoad = useRef(true);

  useEffect(() => {
    if (initialLoad.current) {
      initialLoad.current = false;
      return;
    }
    if (dateRange && dateRange[0] !== undefined && dateRange[1] !== undefined) {
      const init = async () => {
        try {
          setLoading(true);
          await Promise.all([
            getManagerDashboardData(),
            getCounts(),
            getAllUnassignedLeads(1, 10),
            getInactiveAmeyoCount(),
          ]);
        } catch (err) {
          console.error(err);
        } finally {
          setLoading(false);
        }
      };

      init();
    }
  }, [dateRange]);

  const filteredRows = tableData;

  return (
    <Dashboard title="Task Dashboard">
      {checkingPermissions ? (
        <div className="flex justify-center items-center h-64">
          <ReactLoading type="spin" color="#0000FF" />
        </div>
      ) : !permissions.canViewDashboard ? (
        <Card className="mt-3">
          <Result
            icon={<StopOutlined style={{ color: '#ff4d4f' }} />}
            title="You don't have permission to access this page"
            subTitle="Please contact your administrator if you believe this is an error."
          />
        </Card>
      ) : (
        <>
          {loading && (
            <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
          )}
          <div className="py-1 px-1 mb-2 flex justify-between items-center">
            <div className="flex items-center gap-1">
              <h4 className="text-[1.5rem] mb-0">Task Dashboard</h4>
              {permissions.canViewUnassigned && (
                <button
                  onClick={() => {
                    setIsUnAssignedOpen(true);
                    setIsInactiveAmeyoOpen(false);
                    history.push("/manager/dashboard?unassigned=true");
                  }}
                  className="flex outline-none cursor-pointer"
                >
                  <div className="border flex items-center gap-[5px] bg-red-50 !border-red-500 text-red-500 px-3 py-[6px] rounded-l-md text-sm font-medium">
                    New Unassigned:{" "}
                    <span className="font-semibold">{candidates?.totalRecords}</span>
                  </div>
                  <div className="bg-black text-white px-2 rounded-r-md flex items-center">
                    <UserAddOutlined className="!text-[18px]" />
                  </div>
                </button>
              )}
              {/* <button
            onClick={() => {
              setIsInactiveAmeyoOpen(true);
              setIsUnAssignedOpen(false);
              history.push("/manager/dashboard?isServiceActive=false");
            }}
            className="flex outline-none cursor-pointer ml-1"
          >
            <div className="border flex items-center gap-[5px] bg-orange-50 !border-orange-500 text-orange-600 px-3 py-[6px] rounded-l-md text-sm font-medium">
              Ameyo Inactive Leads:{" "}
              <span className="font-semibold">{inactiveAmeyoCount}</span>
            </div>
            <div className="bg-orange-600 text-white px-2 rounded-r-md flex items-center">
              <UserOutlined className="!text-[18px]" />
            </div>
          </button> */}
            </div>
            <div className="flex gap-1">
              <div className="flex items-center">
                <button className="outline-none inline-flex items-center gap-2 px-3 py-1 rounded-md border !border-orange-300 bg-orange-50 text-black text-sm font-medium">
                  <UserOutlined />
                  <span>
                    Total Walk-in:{" "}
                    <span className="font-semibold">{walkInCount}</span>
                  </span>
                </button>
              </div>
              <div className="flex flex-col gap-3 w-fit">
                <div className="flex items-center gap-3">
                  <Select
                    showSearch
                    value={dateFilter}
                    className="w-[200px]"
                    placeholder="Select range"
                    optionFilterProp="children"
                    onChange={(value) => {
                      setDateFilter(value);
                      setDateRange(getDateRange(value));
                    }}
                  >
                    <Select.Option value="today">Today</Select.Option>
                    <Select.Option value="7_days">Last 7 Days</Select.Option>
                    <Select.Option value="15_days">Last 15 Days</Select.Option>
                    <Select.Option value="30_days">Last 30 Days</Select.Option>
                    <Select.Option value="3_months">Last 3 Months</Select.Option>
                    <Select.Option value="custom">Custom Range</Select.Option>
                  </Select>
                </div>

                {dateFilter === "custom" && (
                  <div className="flex items-center gap-3">
                    <RangePicker
                      className="!w-[200px]"
                      format="YYYY-MM-DD"
                      onChange={handleDate}
                      value={[
                        dateRange?.[0] ? moment(dateRange?.[0]) : null,
                        dateRange?.[1] ? moment(dateRange?.[1]) : null,
                      ]}
                      onCalendarChange={handleCalendarChange}
                      disabledDate={disableFutureDates}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          {isUnAssignedOpen ? (
            <UnassignedLeads
              key={`${dateRange[0]}_${dateRange[1]}`}
              candidates={candidates}
              setLoading={setLoading}
              setIsUnAssignedOpen={(open) => {
                setIsUnAssignedOpen(open);
                if (!open) {
                  history.replace("/manager/dashboard");
                }
              }}
              getAllUnassignedLeads={getAllUnassignedLeads}
            />
          ) : isInactiveAmeyoOpen ? (
            <InactiveAmeyoLeads
              key={`${dateRange[0]}_${dateRange[1]}`}
              dateRange={dateRange}
              fetchInactiveCount={getInactiveAmeyoCount}
              setIsInactiveAmeyoOpen={(open) => {
                setIsInactiveAmeyoOpen(open);
                if (!open) {
                  history.replace("/manager/dashboard");
                }
              }}
            />
          ) : (
            <div>
              <Card>
                <div className="flex flex-col gap-[1.5rem]">
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: `repeat(auto-fit, minmax(215px, 1fr))`,
                      gap: "1rem",
                    }}
                    className="mb-4"
                  >
                    {tabCards?.map((item, index) => {
                      return (
                        <div
                          style={{
                            width: "100%",
                          }}
                          key={index}
                        >
                          <Cards item={item} />
                        </div>
                      );
                    })}
                  </div>
                  <div>
                    <Table
                      columns={columns}
                      dataSource={filteredRows}
                      pagination={{
                        total: filteredRows?.length,
                        pageSizeOptions: ["5", "10", "30"],
                        showSizeChanger: true,
                      }}
                      showSorterTooltip={false}
                      scroll={{ x: true }}
                      style={{ whiteSpace: "pre" }}
                      exportFileName="details"
                      size="small"
                    />
                  </div>
                </div>
              </Card>
            </div>
          )}
        </>
      )}
    </Dashboard>
  );
};

export default ManagerDashboard;
